import { createWebHistory } from 'vue-router';
import { initRouter } from './router';
import { routes } from './routes';

export default initRouter(createWebHistory(), routes);

export * from './routes';
export * from './router';
